<template>
  <div>
     <v-app-bar app color="white" class="elevation-3 px-2">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="hidden-sm-and-up"
      ></v-app-bar-nav-icon>
      <!-- <v-divider vertical inset class="hidden-sm-and-up mr-4"></v-divider> -->

      <div class="logo">
        <a href="https://www.accelefreight.com" class="navbar-brand logo">
          <img src="@/assets/logo.svg" alt="AcceleFreight" width="120px" />
        </a>
      </div>

      <v-divider vertical inset class="hidden-xs-only"></v-divider>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <!-- Home -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/home"
          >HOME</v-btn
        >

        <!-- About Us -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/aboutus"
          >ABOUT US</v-btn
        >

        <!-- Our Services -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/ourservices"
          >SERVICES</v-btn
        >

        <!-- F.A.Q -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/frequentquestions"
          >F.A.Q</v-btn
        >

        <!--Contact Us -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          small
          text
          href="https://www.accelefreight.com/contact"
          >CONTACT US</v-btn
        >

       <v-menu bottom offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn class="app-bar-btn font-weight-light body-2" text v-on="on">
              TRACK
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-text-field
                style="max-width: 350px;"
                label="INSERT TRACKING ID"
                outlined
                dense
                height="52"
                class="em-text-field"
                v-model="tracking_id"
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-btn
                depressed
                tile
                large
                block
                color="primary"
                class="font-weight-bold body-1 ml-1"
                @click="trackShipment()"
              >TRACK</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <template v-if="loggedIn">
        <v-btn
          href="https://alfred.accelefreight.com/login"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold mr-4 hidden-sm-and-down"
          >Login</v-btn
        >
        <v-btn
          href="https://alfred.accelefreight.com/register"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold hidden-sm-and-down"
          >Get Started</v-btn
        >
      </template>
      <template v-else>
        <v-btn
          href="https://alfred.accelefreight.com/user/dashboard"
          color="primary"
          tile
          depressed
          small
          class="text-decoration-none font-weight-bold hidden-sm-and-down"
          >Dashboard</v-btn
        >
      </template>
    </v-app-bar>

      <!-- Nav drawer for Mobile/Tab view -->
      <v-navigation-drawer
        app
        temporary
        v-model="drawer"
        class="hidden-md-and-up"
      >
        <template v-slot:prepend>
          <v-row justify="center" class="pt-4">
            <div class="logo">
              <a href="https://www.accelefreight.com" class="navbar-brand logo">
                <img src="@/assets/logo.svg" alt="AcceleFreight" width="150px" />
              </a>
            </div>
          </v-row>
        </template>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item
            href="https://www.accelefreight.com/home"
            class="text-decoration-none"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-light title primary--text"
                >HOME</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item
            href="https://www.accelefreight.com/aboutus"
            class="text-decoration-none"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-light title primary--text"
                >ABOUT US</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item
            href="https://www.accelefreight.com/ourservices"
            class="text-decoration-none"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-light title primary--text"
                >SERVICES</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item
            href="https://www.accelefreight.com/frequentquestions"
            class="text-decoration-none"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-light title primary--text"
                >F.A.Q</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            href="https://www.accelefreight.com/contact"
            class="text-decoration-none"
          >
            <v-list-item-content>
              <v-list-item-title class="font-weight-light title primary--text"
                >CONTACT US</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <!-- <v-divider></v-divider>

          <v-list-item>
            <v-list-item-content>
              <v-menu bottom offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn class="font-weight-light title primary--text" text v-on="on">
                    TRACK
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      style="max-width: 350px;"
                      label="INSERT TRACKING ID"
                      outlined
                      dense
                      height="52"
                      class="em-text-field"
                      v-model="tracking_id"
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-btn
                      depressed
                      tile
                      large
                      block
                      color="primary"
                      class="font-weight-bold body-1 ml-1"
                      @click="trackShipment()"
                    >TRACK</v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-navigation-drawer>

  </div>
</template>

<script>
import constant from "../const";

export default {
  data() {
    return {
      loggedIn: true,
      toggleModalNav: false,
      tracking_id: null,
      drawer: false
    };
  },

  mounted() {
    // if environment is production
    // get the login cookies
    if (this.$cookies.isKey(constant.COOKIES_LOGIN_KEY)) {
      // parse the value to a json
      var parsed_token = this.$cookies.get(constant.COOKIES_LOGIN_KEY);
      if (parsed_token.status == "OK") {
        this.loggedIn = false;
      } else {
        this.loggedIn = true;
      }
    } else {
      console.log("no cookies");
    }
  },

  methods: {
    toggleShowModal() {
      this.toggleModalNav = !this.toggleModalNav;
    },

    navigateTo(page) {
      this.$router.push({ name: page });
      this.toggleModalNav = false;
    },

    /** Track shipment    */
    trackShipment() {
      if (this.tracking_id != null) {
        let url = `https://alfred.accelefreight.com/tracking?id=${this.tracking_id}`;
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style scoped>
.v-btn.app-bar-btn {
  text-decoration: none;
}
.app-bar-btn.v-btn--active {
  color: #1976d2;
  font-weight: bold !important;
  text-decoration: none;
}

.app-bar-btn:hover {
  background-color: #bcd0e4;
}
</style>